import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/**
 * Reusable Alert Modal Component
 * @param {boolean} show - Controls modal visibility
 * @param {function} onHide - Callback when modal is closed
 * @param {string} message - The error/alert message to display
 * @param {string} variant - 'error' | 'warning' | 'info' | 'success' (default: 'error')
 * @param {boolean} showUpgradeButton - Whether to show upgrade to Pro button (default: false)
 */
export default function AlertModal({ show, onHide, message, variant = 'error', showUpgradeButton = false }) {
  const navigate = useNavigate();
  
  const getVariantConfig = () => {
    switch (variant) {
      case 'warning':
        return {
          icon: 'bi-exclamation-triangle-fill',
          color: 'text-warning'
        };
      case 'info':
        return {
          icon: 'bi-info-circle-fill',
          color: 'text-info'
        };
      case 'success':
        return {
          icon: 'bi-check-circle-fill',
          color: 'text-success'
        };
      case 'error':
      default:
        return {
          icon: 'bi-exclamation-triangle-fill',
          color: 'text-danger'
        };
    }
  };

  const config = getVariantConfig();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={`bi ${config.icon} ${config.color}`}></i>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <p className="mb-0 fs-5" style={{ whiteSpace: 'pre-line' }}>{message}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {showUpgradeButton ? (
          <>
            <Button
              variant="primary"
              onClick={() => {
                onHide();
                navigate('/pricing');
              }}
            >
              <i className="bi bi-star-fill me-2"></i>View Pricing
            </Button>
            <Button
              variant="outline-secondary"
              onClick={onHide}
            >
              Maybe Later
            </Button>
          </>
        ) : (
          <Button variant="primary" onClick={onHide}>
            OK
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
